/* SYDZ mockup product page behaviour.
   Custom elements, so the Theme Editor gets correct teardown and nothing
   binds twice when a section is reordered or reloaded. */
(function () {
  'use strict';

  var reduce = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /* ---------------- gallery ---------------- */
  var Gallery = class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      /* Deux listes : toutes les diapositives, et celles visibles pour le
         coloris courant. Les index de Shopify portent sur la liste complète,
         le defilement et le compteur sur la liste visible. Confondre les deux
         faisait sauter la galerie sur une diapositive masquee. */
      this.allSlides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      this.allThumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
      this.slides = this.allSlides;
      this.thumbs = this.allThumbs;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.counter = this.querySelector('[data-counter]');
      if (!this.track || !this.allSlides.length) return;

      this.refresh();
      this.index = 0;
      this.onPrev = this.go.bind(this, -1);
      this.onNext = this.go.bind(this, 1);
      this.onThumb = this.handleThumb.bind(this);
      this.onKey = this.handleKey.bind(this);
      this.onDown = this.handleDown.bind(this);
      this.onMove = this.handleMove.bind(this);
      this.onUp = this.handleUp.bind(this);
      this.onSelect = this.handleSelect.bind(this);

      if (this.prev) this.prev.addEventListener('click', this.onPrev);
      if (this.next) this.next.addEventListener('click', this.onNext);
      this.addEventListener('click', this.onThumb);
      this.addEventListener('keydown', this.onKey);
      this.track.addEventListener('pointerdown', this.onDown);
      document.addEventListener('sydzm:media', this.onSelect);

      this.render();
    }

    disconnectedCallback() {
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      this.removeEventListener('click', this.onThumb);
      this.removeEventListener('keydown', this.onKey);
      if (this.track) this.track.removeEventListener('pointerdown', this.onDown);
      document.removeEventListener('sydzm:media', this.onSelect);
      window.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('pointerup', this.onUp);
    }

    /* Recalcule ce qui est visible apres un changement de coloris. */
    refresh() {
      var vis = function (el) { return !el.hidden; };
      this.slides = this.allSlides.filter(vis);
      this.thumbs = this.allThumbs.filter(vis);
      if (this.index > this.slides.length - 1) this.index = 0;
    }

    /* Une diapositive sans data-color appartient a tous les coloris : photo de
       detail ou video commune aux deux modeles. Elle reste donc visible. */
    applyFilter(color) {
      if (!color) return;
      for (var i = 0; i < this.allSlides.length; i++) {
        var dc = this.allSlides[i].getAttribute('data-color') || '';
        var hide = dc !== '' && dc !== color;
        this.allSlides[i].hidden = hide;
        if (this.allThumbs[i]) this.allThumbs[i].hidden = hide;
      }
      this.refresh();
    }

    handleSelect(event) {
      var d = event.detail || {};
      if (d.color) this.applyFilter(d.color);
      if (typeof d.index === 'number' && d.index >= 0 && d.index < this.allSlides.length) {
        var pos = this.slides.indexOf(this.allSlides[d.index]);
        this.index = pos >= 0 ? pos : 0;
      }
      this.render();
    }

    handleThumb(event) {
      var t = event.target.closest('[data-thumb]');
      if (!t) return;
      this.index = this.thumbs.indexOf(t);
      this.render();
    }

    handleKey(event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); this.go(1); }
    }

    handleDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      this.pid = event.pointerId;
      this.x0 = event.clientX;
      this.dx = 0;
      window.addEventListener('pointermove', this.onMove, { passive: true });
      window.addEventListener('pointerup', this.onUp);
    }
    handleMove(event) { if (event.pointerId === this.pid) this.dx = event.clientX - this.x0; }
    handleUp(event) {
      if (event.pointerId !== this.pid) return;
      window.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('pointerup', this.onUp);
      if (Math.abs(this.dx) > 40) this.go(this.dx < 0 ? 1 : -1);
      this.dx = 0;
    }

    go(step) {
      var n = this.index + step;
      if (n < 0 || n > this.slides.length - 1) return;
      this.index = n;
      this.render();
    }

    render() {
      if (reduce()) this.track.style.transition = 'none';
      this.track.style.transform = 'translateX(' + String(-this.index * 100) + '%)';
      for (var i = 0; i < this.thumbs.length; i++) {
        this.thumbs[i].setAttribute('aria-current', i === this.index ? 'true' : 'false');
      }
      if (this.counter) {
        this.counter.textContent = String(this.index + 1) + ' / ' + String(this.slides.length);
      }
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
    }
  };

  /* ---------------- product: options, quantity, state ---------------- */
  var Product = class extends HTMLElement {
    connectedCallback() {
      var data = this.querySelector('[data-variants]');
      try {
        this.variants = data ? JSON.parse(data.textContent) : [];
      } catch (e) {
        this.variants = [];
      }
      this.optionCount = parseInt(this.dataset.optionCount || '0', 10);
      this.selected = (this.dataset.selected || '').split('~|~').filter(Boolean);

      this.colorPos = parseInt(this.dataset.colorPosition || '-1', 10);
      /* Le titre est hors de ce composant : il porte le nom du modele choisi,
         qui change avec le coloris. */
      this.titleEl = document.querySelector('[data-title]');
      this.priceEl = this.querySelector('[data-price]');
      this.compareEl = this.querySelector('[data-compare]');
      this.hintEl = this.querySelector('[data-hint]');
      this.idInput = this.querySelector('input[name="id"]');
      this.atc = this.querySelector('[data-atc]');
      this.qtyInput = this.querySelector('[data-qty-input]');

      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    handleClick(event) {
      var val = event.target.closest('[data-option-value]');
      if (val && this.contains(val)) {
        var pos = parseInt(val.dataset.optionPosition, 10) - 1;
        this.selected[pos] = val.dataset.optionValue;
        this.update();
        return;
      }
      var step = event.target.closest('[data-qty-step]');
      if (step && this.qtyInput) {
        var n = parseInt(this.qtyInput.value, 10) || 1;
        n += parseInt(step.dataset.qtyStep, 10);
        if (n < 1) n = 1;
        this.qtyInput.value = String(n);
      }
    }

    match(sel) {
      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i];
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] && v.options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    update() {
      var self = this;

      /* Mark each option value available or not against the rest of the
         current selection, so sold-out combinations are visible up front. */
      var buttons = this.querySelectorAll('[data-option-value]');
      Array.prototype.forEach.call(buttons, function (btn) {
        var pos = parseInt(btn.dataset.optionPosition, 10) - 1;
        var probe = self.selected.slice();
        probe[pos] = btn.dataset.optionValue;
        var found = self.match(probe);
        btn.setAttribute('aria-checked', self.selected[pos] === btn.dataset.optionValue ? 'true' : 'false');
        btn.dataset.unavailable = found && found.available ? 'false' : 'true';
      });

      /* Le libelle « — valeur » a cote du nom d'option etait rendu une seule
         fois par le serveur : apres un changement de coloris ou de taille il
         annoncait encore l'ancienne valeur, en contradiction avec la pastille
         cochee juste en dessous. */
      var labels = this.querySelectorAll('[data-option-selected]');
      Array.prototype.forEach.call(labels, function (el) {
        var pos = parseInt(el.dataset.optionSelected, 10) - 1;
        var v = self.selected[pos];
        el.textContent = v ? '— ' + v : '';
      });

      var complete = this.selected.filter(Boolean).length === this.optionCount;
      var variant = complete ? this.match(this.selected) : null;

      if (this.priceEl && variant) this.priceEl.innerHTML = variant.price;
      if (this.compareEl) {
        if (variant && variant.compare) {
          this.compareEl.innerHTML = variant.compare;
          this.compareEl.hidden = false;
        } else {
          this.compareEl.hidden = true;
        }
      }

      if (this.idInput) {
        this.idInput.value = variant ? String(variant.id) : '';
        this.idInput.disabled = !variant || !variant.available;
      }

      if (this.atc) {
        var label = this.atc.querySelector('[data-atc-label]');
        if (!complete) {
          this.atc.disabled = true;
          if (label) label.textContent = this.dataset.labelChoose || 'Select options';
        } else if (!variant) {
          this.atc.disabled = true;
          if (label) label.textContent = this.dataset.labelUnavailable || 'Unavailable';
        } else if (!variant.available) {
          this.atc.disabled = true;
          if (label) label.textContent = this.dataset.labelSoldOut || 'Sold out';
        } else {
          this.atc.disabled = false;
          if (label) label.textContent = this.dataset.labelAdd || 'Add to cart';
        }
      }

      if (this.hintEl) {
        this.hintEl.textContent = complete ? '' : (this.dataset.hintChoose || 'Choose a size to continue.');
      }

      /* Keep the address bar on the selected variant so the link can be
         shared and the back button behaves. */
      if (variant && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
      }

      /* Le coloris part a chaque mise a jour, pas seulement quand une variante
         complete est trouvee : le client peut choisir sa couleur avant sa
         taille, et la galerie doit suivre des ce moment-la. */
      var color = this.colorPos >= 0 ? (this.selected[this.colorPos] || '') : '';
      var idx = variant && typeof variant.media === 'number' ? variant.media : -1;
      if (color || idx >= 0) {
        document.dispatchEvent(new CustomEvent('sydzm:media', { detail: { index: idx, color: color } }));
      }
      if (this.titleEl) {
        this.titleEl.textContent = color || this.dataset.productTitle || this.titleEl.textContent;
      }
    }
  };

  /* ---------------- accordions ---------------- */
  var Acc = class extends HTMLElement {
    connectedCallback() {
      this.onClick = this.handle.bind(this);
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); }
    handle(event) {
      var btn = event.target.closest('[data-acc-toggle]');
      if (!btn || !this.contains(btn)) return;
      var panel = this.querySelector('#' + btn.getAttribute('aria-controls'));
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.setAttribute('data-open', open ? 'false' : 'true');
    }
  };

  if (!customElements.get('sydzm-gallery')) customElements.define('sydzm-gallery', Gallery);
  if (!customElements.get('sydzm-product')) customElements.define('sydzm-product', Product);
  if (!customElements.get('sydzm-acc')) customElements.define('sydzm-acc', Acc);
})();
